import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';

const EditSuggestionDialog = ({
  open,
  onOpenChange,
  business,
  form,
  setForm,
  categories,
  onSubmit,
  isSubmitting
}) => {
  if (!business) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Suggest an Edit</DialogTitle>
          <p className="text-sm text-muted-foreground">
            Suggest changes to: <span className="font-medium">{business.business_name}</span>
          </p>
        </DialogHeader>
        
        <div className="space-y-4 pt-2">
          <div>
            <Label className="text-sm">Website</Label>
            <Input
              value={form.website}
              onChange={(e) => setForm({...form, website: e.target.value})}
              placeholder="https://example.com"
            />
          </div>
          
          <div>
            <Label className="text-sm">Contact (Phone/Email)</Label>
            <Input
              value={form.contact}
              onChange={(e) => setForm({...form, contact: e.target.value})}
              placeholder="phone or email"
            />
          </div>
          
          <div>
            <Label className="text-sm">Address/Location</Label>
            <Input
              value={form.address}
              onChange={(e) => setForm({...form, address: e.target.value})}
              placeholder="City, State"
            />
          </div>
          
          <div>
            <Label className="text-sm">Categories</Label>
            <div className="max-h-32 overflow-y-auto border rounded p-2 mt-1 space-y-1">
              {categories.map(cat => (
                <label key={cat} className="flex items-center gap-2 text-sm cursor-pointer">
                  <Checkbox
                    checked={form.categories.includes(cat)}
                    onCheckedChange={(checked) => {
                      if (checked) {
                        setForm({...form, categories: [...form.categories, cat]});
                      } else {
                        setForm({...form, categories: form.categories.filter(c => c !== cat)});
                      }
                    }}
                  />
                  {cat}
                </label>
              ))}
            </div>
          </div>
          
          <div className="border-t pt-4">
            <p className="text-xs text-muted-foreground mb-2">Optional: Your contact info (for follow-up)</p>
            <div className="grid grid-cols-2 gap-2">
              <Input
                value={form.submitterName}
                onChange={(e) => setForm({...form, submitterName: e.target.value})}
                placeholder="Your name"
              />
              <Input
                value={form.submitterEmail}
                onChange={(e) => setForm({...form, submitterEmail: e.target.value})}
                placeholder="Your email"
              />
            </div>
          </div>
          
          <div className="flex justify-end gap-2 pt-2">
            <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
            <Button onClick={onSubmit} disabled={isSubmitting}>
              {isSubmitting ? 'Submitting...' : 'Submit Suggestion'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default EditSuggestionDialog;
